import MaisEguPage from './components/MaisEguPage';
import { menuAfterIcon } from '../../utils/formatters';
import CheckTypesPage from './components/CheckTypesPage';
import ChecksPage from './components/ChecksPage';
import ChecksErrorPage from './components/ChecksErrorPage';
import FileExportPage from './components/FileExportPage';

const routes = [
  {
    path: '/integration/mais-egu',
    name: 'menu.integration',
    icon: 'settings',
    customIcon: true,
    loginRequired: true,
    component: MaisEguPage,
    weight: 2,
    permission: [],
    children: [
      {
        path: '/integration/mais-egu',
        name: 'menu.integration.mais.egu',
        loginRequired: true,
        component: MaisEguPage,
        weight: 2,
        permission: [],
        children: [],
      },
      {
        path: '/integration/check-types',
        name: 'menu.integration.request.template',
        icon: 'application',
        customIcon: true,
        loginRequired: true,
        afterContent: menuAfterIcon(),
        component: CheckTypesPage,
        weight: 2,
        permission: [],
        children: [],
      },
      {
        path: '/integration/request-list',
        name: 'menu.integration.request.list',
        icon: 'application',
        customIcon: true,
        loginRequired: true,
        component: ChecksPage,
        weight: 2,
        permission: [],
        children: [],
      },
      {
        path: '/integration/error-list',
        name: 'menu.integration.error.list',
        icon: 'application',
        customIcon: true,
        loginRequired: true,
        component: ChecksErrorPage,
        weight: 2,
        permission: [],
        children: [],
      },
      // {
      //   path: '/integration/template-registry',
      //   name: 'menu.integration.template.registry',
      //   icon: 'application',
      //   customIcon: true,
      //   loginRequired: true,
      //   component: () => {},
      //   weight: 2,
      //   permission: [],
      //   children: [],
      // },
      // {
      //   path: '/integration/template-registry-list',
      //   name: 'menu.integration.template.registry.list',
      //   icon: 'application',
      //   customIcon: true,
      //   loginRequired: true,
      //   component: () => {},
      //   weight: 2,
      //   permission: [],
      //   children: [],
      // },
      // {
      //   path: '/integration/file-export',
      //   name: 'menu.integration.file.export',
      //   icon: 'application',
      //   customIcon: true,
      //   loginRequired: true,
      //   component: FileExportPage,
      //   weight: 2,
      //   permission: [],
      //   children: [],
      // },
    ],
  },
];

export default routes;
